import { render, staticRenderFns } from "./SelfSelect.vue?vue&type=template&id=22fa4f12&scoped=true"
import script from "./SelfSelect.vue?vue&type=script&lang=js"
export * from "./SelfSelect.vue?vue&type=script&lang=js"
import style0 from "./SelfSelect.vue?vue&type=style&index=0&id=22fa4f12&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22fa4f12",
  null
  
)

export default component.exports